(function() {
    // Must be in seconds
    const COOKIE_AGE = 60 * 60 * 24 * 90; // 90 days

    // Parameter names for click IDs
    const CLICK_IDS = [
        'gclid',
        'msclkid',
        'fbclid'
    ];

    function handleClickIds() {
        const params = new URLSearchParams(window.location.search);

        // Only run if the cookie consent is given for marketing: https://www.cookiebot.com/en/developer
        if (!window.CookieConsent?.consent?.marketing) {
            return;
        }

        CLICK_IDS.forEach(async (name) => {
            const value = params.get(name);
            if (!value || value === '') {
                return;
            }

            // Always set the newest clickId
            setCookie(name, value);

            if (name === 'fbclid') {
                const fbc = await window.cookieStore.get("_fbc");

                if (!fbc?.value) {
                    setCookie("_fbc", `fb.2.${getCurrentTimestamp()}.${value}`);
                }
            }
        });
    }

    function setCookie(name, value) {
        window.cookieStore.set({
            name: name,
            value: value,
            maxAge: COOKIE_AGE,
        });
    }

    function getCurrentTimestamp() {
        return Math.floor(Date.now() / 1000);
    }

    window.addEventListener('CookiebotOnConsentReady', handleClickIds, false);
})();
